export default {
  data() {
    return {
      valid: {
        gift_category: false,
        gift_type: false,
        image: true,
        title: false,
        description: false,
        points: false,
        cost: false,
        supplier: false,
        tier: !this.tierSwitch,
      },
      success: {
        gift_category: false,
        gift_type: false,
        image: false,
        title: false,
        description: false,
        points: false,
        cost: false,
        tier: !this.tierSwitch,
        supplier: false,
      },
      error: {
        gift_category: '',
        gift_type: '',
        image: '',
        title: '',
        description: '',
        points: '',
        cost: '',
        tier: '',
        supplier: '',
      },
      errorMessages: {
        giftCategoryRequired: {
          el: 'Απαιτείται κατηγορία δώρου',
          en: 'Gift Category is required',
          it: 'La categoria regalo è obbligatoria',
        },
        giftTypeRequired: {
          el: 'Απαιτείται τύπος δώρου',
          en: 'Gift Type is required',
          it: 'Il tipo di regalo è obbligatorio',
        },
        titleRequired: {
          el: 'Απαιτείται τίτλος',
          en: 'Title is required',
          it: 'Il titolo è obbligatorio',
        },
        descriptionRequired: {
          el: 'Απαιτείται περιγραφή',
          en: 'Description is required',
          it: 'La descrizione è obbligatoria',
        },
        pointsRequired: {
          el: 'Απαιτούνται πόντοι',
          en: 'Points are required',
          it: 'I punti sono obbligatori',
        },
        cashbackRequired: {
          el: 'Απαιτείται cashback',
          en: 'Cashback is required',
          it: 'Il cashback è obbligatorio',
        },
        costRequired: {
          el: 'Απαιτείται κόστος',
          en: 'Cost is required',
          it: 'Il costo è obbligatorio',
        },
        supplierRequired: {
          el: 'Απαιτείται προμηθευτής',
          en: 'Supplier is required',
          it: 'Il fornitore è obbligatorio',
        },
        imageTooLarge: {
          el: 'Η εικόνα υπερβαίνει το όριο %dKB',
          en: 'Image exceeds %dKB limit',
          it: "L'immagine supera il limite di %dKB",
        },
        imageInvalidType: {
          el: 'Η εικόνα πρέπει να είναι PNG/JPG/JPEG',
          en: 'Image must be png/jpg/jpeg',
          it: "L'immagine deve essere png/jpg/jpeg",
        },
        tierRequired: {
          el: 'Επιλέξτε επίπεδο',
          en: 'Tier is required',
          it: 'Il livello è obbligatorio',
        },
      },
    };
  },

  computed: {
    formValid() {
      return (
        this.valid.gift_category &&
        this.valid.gift_type &&
        this.valid.image &&
        this.valid.title &&
        this.valid.description &&
        this.valid.points &&
        this.valid.cost
      );
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
  },

  methods: {
    validateImage(file) {
      if (!file) {
        this.error.image = '';
        this.valid.image = true;
        this.success.image = false;
        return true;
      }

      const maxKB = 5000;
      const maxBytes = maxKB * 1024;
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

      if (file.size > maxBytes) {
        const msgTemplate =
          this.errorMessages.imageTooLarge[this.lang] || `Image exceeds ${maxKB}KB limit`;
        this.error.image = msgTemplate.replace('%d', maxKB);
        this.valid.image = false;
        this.success.image = false;
        return false;
      }

      if (!allowedTypes.includes(file.type)) {
        this.error.image = this.errorMessages.imageInvalidType[this.lang];
        this.valid.image = false;
        this.success.image = false;
        return false;
      }

      this.error.image = '';
      this.valid.image = true;
      this.success.image = true;
      return true;
    },

    validateGiftCategory() {
      if (!this.giftData.gift_category_id) {
        this.error.gift_category = this.errorMessages.giftCategoryRequired[this.lang];
      } else {
        this.error.gift_category = '';
      }
    },

    validateGiftType() {
      if (!this.giftData.gift_type_id) {
        this.error.gift_type = this.errorMessages.giftTypeRequired[this.lang];
      } else {
        this.error.gift_type = '';
      }
    },

    validateTitle() {
      if (!this.giftData.title) {
        this.error.title = this.errorMessages.titleRequired[this.lang];
      } else {
        this.error.title = '';
      }
    },

    validateDescription() {
      if (!this.giftData.description) {
        this.error.description = this.errorMessages.descriptionRequired[this.lang];
      } else {
        this.error.description = '';
      }
    },

    validatePoints() {
      if (
        this.giftData.points === null ||
        this.giftData.points === undefined ||
        this.giftData.points === ''
      ) {
        this.error.points = this.errorMessages[`${this.storeMode}Required`][this.lang];
      } else {
        this.error.points = '';
      }
    },

    validateCost() {
      if (
        this.giftData.cost === null ||
        this.giftData.cost === undefined ||
        this.giftData.cost === ''
      ) {
        this.error.cost = this.errorMessages.costRequired[this.lang];
      } else {
        this.error.cost = '';
      }
    },

    validateSupplier() {
      if (!this.giftData.supplier_store_id) {
        this.error.supplier = this.errorMessages.supplierRequired[this.lang];
      } else {
        this.error.supplier = '';
      }
    },

    validateTier() {
      if (this.tierSwitch && !this.giftData.store_point_title_id) {
        this.error.tier = this.errorMessages.tierRequired[this.lang];
      } else {
        this.error.tier = '';
        this.success.tier = !!this.giftData.store_point_title_id;
        this.valid.tier = parseInt(this.giftData.store_point_title_id) > 0;
      }
    },
  },

  watch: {
    ['giftData.gift_category_id']: {
      immediate: true,
      handler(val) {
        this.valid.gift_category = !!val;
        this.success.gift_category = !!val;
      },
    },

    ['giftData.gift_type_id']: {
      immediate: true,
      handler(val) {
        this.valid.gift_type = !!val;
        this.success.gift_type = !!val;
      },
    },

    ['giftData.title']: {
      immediate: true,
      handler(val) {
        this.valid.title = !!val;
        this.success.title = !!val;
      },
    },

    ['giftData.description']: {
      immediate: true,
      handler(val) {
        this.valid.description = !!val;
        this.success.description = !!val;
      },
    },

    ['giftData.points']: {
      immediate: true,
      handler(val) {
        this.valid.points = !(val === null || val === undefined || val === '');
        this.success.points = !(val === null || val === undefined || val === '');
      },
    },

    ['giftData.cost']: {
      immediate: true,
      handler(val) {
        this.valid.cost = !(val === null || val === undefined || val === '');
        this.success.cost = !(val === null || val === undefined || val === '');
      },
    },

    ['giftData.supplier_store_id']: {
      immediate: true,
      handler(val) {
        this.valid.supplier = !!val;
        this.success.supplier = !!val;
      },
    },

    ['giftData.store_point_title_id']: {
      immediate: true,
      handler(val) {
        this.valid.tier = !this.tierSwitch || (this.tierSwitch && !!val);
        this.success.tier = true || !this.tierSwitch || (this.tierSwitch && !!val);
      },
    },

    resetSuccess(val) {
      if (val) {
        this.success = {
          gift_category: false,
          gift_type: false,
          image: false,
          title: false,
          description: false,
          points: false,
          cost: false,
          tier: false,
          success: false,
        };

        this.setResetSuccess(false);
      }
    },

    resetValidation: {
      immediate: true,
      handler(val) {
        if (val) {
          this.error = {
            gift_category: '',
            gift_type: '',
            image: '',
            title: '',
            description: '',
            points: '',
            cost: '',
            tier: '',
            success: '',
          };

          this.setResetValidation(false);
        }
      },
    },
  },
};
